import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'  // This makes it available throughout the app
})
export class Base64UrlService {
  // Encode string to URL-safe Base64
  static encode(input: string): string {
    const base64 = btoa(input);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  // Decode URL-safe Base64 back to original string
  static decode(input: string): string {
    let base64 = input.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    return atob(base64);
  }
}
